import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { INACTIVITY_EXCEPTION_URLS } from '../constants';
import { API } from './api';
import SessionTimeoutModal from '../components/SessionTimeoutModal/SessionTimeoutModal';
import { setAuthToken, setRecentAPICalls, setRemainingTime } from '../redux/features/auth/actions';
import { authData } from '../redux/selectors/authSelector';

const ApiBasedInactivityCheck = ({ setRefresh, logoutUser }) => {
	const authState = useSelector(authData);
	const { authToken, user, remainingTime } = authState;
	const [showSessionTimeout, setShowSessionTimeout] = useState(false);
	const dispatch = useDispatch();

	const isExceptionUrl = (url) => {
		if (
			Object.values(INACTIVITY_EXCEPTION_URLS).filter((exurl) => url === exurl)
				.length > 0
		)
			return true;
		return false;
	};

	const loadApiRequestAuthInterceptor = (instance) => {
		const newAuthInterceptor = instance.interceptors.request.use((req) => {
			if (req && req.url) {
				if (isExceptionUrl(req.url)) {
					let recentCalls = localStorage.getItem('recentApiUrls');
					recentCalls += ',invalid';
					localStorage.setItem('recentApiUrls', recentCalls);
				} else {
					let recentCalls = localStorage.getItem('recentApiUrls');
					recentCalls += `,${req.url}`;
					localStorage.setItem('recentApiUrls', recentCalls);
				}
			}
			return req;
		});
		return newAuthInterceptor;
	};

	const checkIfApiCalled = () => {
		const filteredUrls = localStorage
			.getItem('recentApiUrls')
			.split(',')
			.filter((url) => url !== 'initial' && url !== 'invalid');
		if (filteredUrls) {
			dispatch(setRecentAPICalls(filteredUrls));
			localStorage.setItem('recentApiUrls', 'initial');
		}
	};

	useEffect(() => {
		setInterval(() => {
			checkIfApiCalled();
		}, 60000);
		localStorage.setItem('stopApiCalls', false);
		localStorage.setItem('recentApiUrls', 'initial');
	}, []);

	useEffect(() => {
		if (user && user.isLoaded) loadApiRequestAuthInterceptor(API);
	}, [user]);

	useEffect(() => {
		let timer;
		if (remainingTime) {
			timer = setTimeout(() => {
				setShowSessionTimeout(true);
				localStorage.setItem('stopApiCalls', true);
			}, remainingTime);
		}
		return () => {
			clearTimeout(timer);
		};
	}, [remainingTime, authToken]);

	return (
		<SessionTimeoutModal
			open={showSessionTimeout}
			setOpen={setShowSessionTimeout}
			handleClose={() => {
				setShowSessionTimeout(false);
			}}
			confirmSubmit={() => setRefresh(true)}
			logoutUser={() => {
				logoutUser();
			}}
		/>
	);
};

ApiBasedInactivityCheck.propTypes = {
	setRefresh: PropTypes.func,
	logoutUser: PropTypes.func,
};

export default connect(
	(state) => ({
		keycloak: state.auth.keycloak,
		authToken: state.auth.authToken,
		remainingTime: state.auth.remainingTime,
		user: state.auth.user,
		recentAPICalls: state.auth.recentAPICalls,
		setRefresh: state.auth.setRefresh,
		logoutUser: state.auth.logoutUser,
	}),
	{
		setRemainingTime,
		setRecentAPICalls,
		setAuthToken,
	}
)(ApiBasedInactivityCheck);
